<template>
  <el-dialog :visible.sync="editSetDialog" width="420px" :title="editTitle" class="addBrand">
    <el-form :model="queryParams" label-width="100px" :inline="true">
      <el-form-item label="选项名称：">
        <el-input v-model="queryParams.attrName"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提 交</el-button>
      <el-button @click="onCancel">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { attrContentAdd, attrContentUpdate } from '@/api/system/rightsManagement'
export default {
  data () {
    return {
      queryParams: {
        attrName: ''
      },
      editSetDialog: false,
      editTitle: '编辑', // 编辑添加标题
      calssCode: ''
    }
  },
  methods: {
    // 编辑添加弹窗初始状态
    setInit (val, type) {
      this.queryParams = { attrName: '' }
      if (val === 'add') {
        this.editTitle = '添加'
        this.calssCode = type
      } else {
        this.queryParams = JSON.parse(JSON.stringify(val))
        this.editTitle = '编辑'
      }
      this.editSetDialog = true
    },
    // 提交
    onSubmit () {
      if (this.queryParams.attrName === '' || this.queryParams.attrName === undefined || this.queryParams.attrName === null) {
        this.$message.error('选项名称不能为空!')
      } else {
        if (this.editTitle === '添加') { // 添加
          attrContentAdd(this.calssCode, this.queryParams).then(res => {
            if (res.data.code === 200) {
              this.editSetDialog = false
              this.$message.success('添加成功!')
              this.$emit('onRefresh')
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        } else { // 编辑
          attrContentUpdate(this.queryParams).then(res => {
            if (res.data.code === 200) {
              this.editSetDialog = false
              this.$message.success('编辑成功!')
              this.$emit('onRefresh')
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    // 取消
    onCancel () {
      this.editSetDialog = false
      this.queryParams = {
        attrName: ''
      }
    }
  }
}
</script>

<style>

</style>
